const TRANSLATION = {
  buyModal: {
    afterFree: 'Baada ya majaribio yako ya bure',
    btn: 'Jaribu Bila Malipo',
    freeTrial: 'Majaribio ya 3 Siku bila Malipo',
    monthLabel: 'mwezi',
    selectLabel: 'Chagua mpango',
    title: ' Mpango wa Usajili',
    yearLabel: 'mwaka',
  },
  contact: {
    block1:
      'Kwa marekebisho, maswali, au mawazo, tafadhali wasilisha uwezo wetu kwa contact@noam.tools. Tutajaribu kujibu haraka.',
    block2: 'Tusaidie kwa kutoandika ushahidi wetu kwenye duka la Google Apps Extension kwa ★★★★★.',
    block3: 'Usaidie wengine kwa kuchambua mfano huu:',
    title: 'Wasilisha Nasi',
  },
  help: {
    AquickOverviewOfNoam: 'Mwendesha Haraka wa Noam',
    ChatPDF: 'Chat PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'Usimamizi wa Mafavorite',
    Fixedplugin: 'Plugin Iliyoshtakiwa',
    Focusing: 'Kuzingatia',
    Free: 'Furahia',
    FreeTrialBenefits: 'Manufaa ya Majaribio ya Frei',
    GoWithWikipedia: 'Tumia Wikipedia',
    GoWithYouTube: 'Endesha na YouTube',
    HoverTranslation: 'Tafsiri ya Hover',
    Howtouse: 'Jinsi ya Kutumia',
    ImageTranslation: 'Tafsiri ya Picha',
    InstantTranslation: 'Tafsiri Ya Haraka',
    Membership: 'Ushiriki',
    NoamHelp: 'Noam anakusaidia kutafsiri na kuchambua mazungumzo',
    PDFparallelTranslation: 'Tafsiri ya Paraleli ya PDF',
    ParallelTranslation: 'Tafsiri ya Paraleli',
    SkipAllSteps: 'Sahihiwa Hatua Zote',
    Summary: 'Muhtasari',
    Translation: 'Tafsiri',
    TryItForFree: 'Jaribu Bila Malipo',
    Video: 'Video',
    VideoSummary: 'Muhtasari wa Video',
    VideoTranslation: 'Tafsiri ya Video',
    WebSummary: 'Muhtasari wa Wavuti',
    WordSelectionTranslation: 'Uchambua Maneno na Tafsiri',
    benefits: 'Tuna manufaa yanayokwenda kukuwa kwako!',
    dayFree: 'Majaribio ya 3 Siku Bila Malipo',
    done: 'Kwa kila',
    next: 'Ila',
    pin: 'Weka Noam kwa uwezo wa kufungua kwa urahisi～～',
    planIsNotExist: 'Planu hauwezekanwi',
    startWiki: 'Hebu kuanza na Wikimedia!',
    startYoutube: 'Hebu kuanza na YouTube!',
    try: 'Jaribu',
    tryNow: 'Jaribu sasa!',
  },
  home: {
    PDFTranslate: {
      desc: 'Tafsiri ya Lugha Mbili + Mazungumzo ya PDF',
      sub1: {
        desc: 'Usoma wa lugha mbili unakuruhusu kutoana na maandiko asili na tafsiri kwa kando, kuchambua uwezo wa kusoma.',
        title: 'Usomaji wa Lugha Mbili',
      },
      sub2: {
        desc: 'AI inachambua na kuchambua vigezo, na inaweza kujibu maswali yako kulingana na maudhui ya PDF.',
        title: 'Chat PDF',
      },
      sub3: {
        desc: 'Tafsiri ya PDF yenye nguvu ya AI kwa usahihi na uwezo wa kufanya kazi zaidi.',
        title: 'Usahihi na Uwezo wa Kazi',
      },
      title: 'Tafsiri PDF',
    },
    aiAssistant: {
      desc: 'Kufanya Utafsiri wa Wavuti Uwe Na Akili na Rahisi Zaidi',
      panel1: {
        desc: 'Mawinguzi yenye ushiriki wa lugha mbili husaidia kutoana na maandishi ya asili na maadili ili uweze kuelewa zaidi na kuwasilisha uwezo wako wa kusoma.',
        title: 'Tafsiri ya Lugha Mbili',
      },
      panel2: {
        left: {
          desc: 'Unapochambua ukurasa wa wavuti, weka mwenendo wa mouse kwenye maudhui unayotaka kutafsiri ili kuona tafsiri.',
          title: 'Tafsiri ya Kuzingatia',
        },
        right: {
          desc: 'Unapokuwa unazingatia ukurasa wa wavuti, chagua maandishi unayotaka kuchambua ili kuona tafsiri.',
          title: 'U翻訳 wa Chaguo la Teksto',
        },
      },
      panel3: {
        one: {
          desc: 'Tafsiri na ufasili maudhui ya kurasa za wavuti na video katika wakati wowote, mahali popote, kwa uzoefu wa kupendeza zaidi!',
          title: 'Pointee na Klicki',
        },
        three: {
          desc: 'Modeli kubwa ya lugha inayotawalawa na AI inahakikisha usahihi na kuzingatia mabadiliko katika tafsiri kwa uwezo wa kusoma uliowezekana.',
          title: 'Inayotokana na AI',
        },
        two: {
          desc: 'Ufuatiliaji wa jumla wa lugha nyingi, kusoma bila kizuizi kwa lugha mbili, tafsiri kwa klick moja - uzoee tofauti!',
          title: 'Zaidi ya Ukomprehensive na Rahisi',
        },
      },
      panel4: {
        tab1: {
          desc: 'Mwendesha uwezo wako wa uwezo - kwa kutumia ChatGPT, Noam hutafsiri na kuchambua maelezo ya video za YouTube ili kukusave muda!',
          key: 'Video',
          title: 'Tafsiri na Muhtasari wa Video',
        },
        tab2: {
          desc: 'Bonyeza kuchambua picha unapochambua wavuti.',
          key: 'Picha',
          title: 'Tafsiri Picha',
        },
        tab3: {
          desc: 'Inachambua maelezo yenye uwezo wa kutoa muhtasari wa haraka kutoka kwenye kurasa za wavuti, na huku ikiongeza uwezo wako wa kusoma.',
          key: 'Wavuti',
          title: 'Tafsiri wa Wavuti & Muhtasari',
        },
        tag1: 'Rahisi',
        tag2: 'Mefaa',
        tag3: 'Rahisi Kuelewa',
      },
      title: 'Mwendesha AI',
    },
    getStart: 'Anza',
    getStartedForFree: 'Anza kwa bure',
    howItWork: {
      desc: 'Noam inajumuisha mifano ya AI kutoa watumiaji uzoefu wa akili kwa usahihi wa kurudia na kuchambua ukurasa wa wavuti kati ya lugha, usahihi wa PDF na picha, usahihi wa video na kuchambua',
      title: 'Jinsi inavyofanya kazi',
    },
    lastBlock: { desc: 'Tafsiri bora zaidi ya AI kwa uwezo wa kusoma unaofaa zaidi' },
    top: {
      desc: 'Noam ni mfano wa kutoa usaidizi wa AI wa bure kwenye kivinjari unaouwezesha kuchambua uamuzi wa lugha na kuchambua maelezo ya kuratibu kwenye kurasa za wavuti, video, na mawasiliano ya PDF.\n      Jiunge na Noam na uwekewa na mavazi ya ajali!',
      title1: 'Uwezo wa Kutoa',
      title2: 'Kuchambua Mara Moja',
    },
    userReviews: {
      desc: 'Maoni yenye nyota tano kwenye Chrome Web Store',
      title: 'Maoni ya Watumiaji',
    },
  },
  installTips: {
    btn: 'Jaribu Sasa',
    text: 'Pakia "Noam Browser Plugin" ili kufungua vigezo vingi zaidi! Ushirikiano wa wavuti,\n    muhtasari wa video za wavuti, na zaidi!',
  },
  locale: {
    af: 'Afrikaans',
    am: 'Kimhariki',
    ar: 'Kiarabu',
    as: 'Assamese',
    auto: 'Kuchunguza Automatically',
    az: 'Azerbaijani',
    ba: 'Bashkir',
    bg: 'Bulgaria',
    bn: 'Bangla',
    bo: 'Tibeti',
    bs: 'Bosnia',
    ca: 'Katali',
    cs: 'Cheki',
    cy: 'Walishi',
    da: 'Kidanishi',
    de: 'Kijerumani',
    dsb: 'Sorbia ya Chini',
    dv: 'Divehi',
    el: 'Kigiriki',
    en: 'Kiingereza',
    es: 'Kihispania',
    et: 'Estonia',
    eu: 'Basque',
    fa: 'Farsi',
    fi: 'Kifinlandi',
    fil: 'Filipino',
    fj: 'Fijian',
    fr: 'Kifaransa',
    frCA: 'Kifaransa (Kanada)',
    ga: 'Wairish',
    gl: 'Galicia',
    gom: 'Konkani',
    gu: 'Gujarati',
    ha: 'Hausa',
    he: 'Kihaburu',
    hi: 'Hindi',
    hr: 'Kroeshia',
    hsb: 'Sorbia ya Juu',
    ht: 'Kreyoli ya Haiti',
    hu: 'Hungari',
    hy: 'Armenia',
    id: 'Indonesia',
    ig: 'Igbo',
    ikt: 'Inuinnaqtun',
    is: 'Icelandic',
    it: 'Kitali',
    iu: 'Inuktitut',
    iuLatn: 'Inuktitut (Latin)',
    ja: 'Kijapani',
    ka: 'Georgia',
    kk: 'Kazakh',
    km: 'Kikhemri',
    kmr: 'Kurdish (Kaskazini)',
    kn: 'Kannada',
    ko: 'Korea',
    ku: 'Kurdish (Kati)',
    ky: 'Kyrgyz',
    ln: 'Lingala',
    lo: 'Lao',
    lt: 'Lithuania',
    lug: 'Ganda',
    lv: 'Lativia',
    lzh: 'Kiwekendi (Kiandishi)',
    mai: 'Maithili',
    mg: 'Malagasy',
    mi: 'Māori',
    mk: 'Makedonia',
    ml: 'Malayalam',
    mnCyrl: 'Kimonolia (Cyrillic)',
    mnMong: 'Mongolia (Kihistoria)',
    mr: 'Marathi',
    ms: 'Malay',
    mt: 'Kimaltezi',
    mww: 'Hmong Daw',
    my: 'Myanmar (Burmese)',
    nb: 'Kijenevizi',
    ne: 'Nepali',
    nl: 'Holland',
    noSearchLang: 'Lugha haupendekezwa',
    nso: 'Sesotho sa Leboa',
    nya: 'Kinyanja',
    or: 'Odia',
    otq: 'Querétaro Otomi',
    pa: 'Punjabi',
    pl: 'Polish',
    placeholder: 'Tafuta',
    prs: 'Dari',
    ps: 'Pashto',
    pt: 'Kiporutugi (Brazil)',
    ptPT: 'Kiporutugali (Ukwetu)',
    ro: 'Rumani',
    ru: 'Urusi',
    run: 'Rundi',
    rw: 'Kinyarwanda',
    sd: 'Sindhi',
    si: 'Sinhala',
    sk: 'Slovakia',
    sl: 'Slovenia',
    sm: 'Samoan',
    sn: 'Kishona',
    so: 'Somali',
    sq: 'Albania',
    srCyrl: 'Kiserbia (Cyrillic)',
    srLatn: 'Kiserbia (Laatini)',
    st: 'Sesotho',
    sv: 'Uswidi',
    sw: 'Kiswahili',
    ta: 'Tamil',
    te: 'Telugu',
    th: 'Thai',
    ti: 'Tigrinya',
    tk: 'Turkmen',
    tlhLatn: 'Klingon',
    tlhPiqd: 'Klingon (pIqaD)',
    tn: 'Kisetswana',
    to: 'Mwatongani',
    tr: 'Turki',
    tt: 'Tatar',
    ty: 'Tahitiani',
    ug: 'Uyghur',
    uk: 'Ukraine',
    ur: 'Urdu',
    uz: 'Uzbek (Latin)',
    vi: 'Kivietnam',
    xh: 'Kixhosa',
    yo: 'Yoruba',
    yua: 'Yucatec Maya',
    yue: 'Kikanthoni (Kihistoria)',
    zh: 'Weusi wa China',
    zhHans: 'Kiingereza cha Ufasihi',
    zhHant: 'Kiwekendesi cha Kichina',
    zu: 'Zulu',
  },
  login: {
    and: 'na',
    btn: 'Ingia kwa Google',
    btn1: 'Ingia Sasa',
    desc: 'Ingia kwenye akaunti yako ili kufungua uzoefu zaidi',
    policy: 'Kanuni ya Uhalifu',
    terms: 'Sharti za Matumizi',
    tips: 'Kwa kujisajiliwa, ninakubali na',
    title: 'Karibu Noam',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Fuata', twitter: 'Twitter' },
    legal: {
      policy: 'Kanuni ya Haki za Juu ya Usalama wa Maelezo',
      terms: 'Sharti za Huduma',
      title: 'Kikatiba',
    },
    product: {
      image: 'Tafsiri ya Picha',
      pdf: 'Tafsiri ya PDF',
      title: 'Vifaa',
      video: 'Tafsiri na Muhtasari wa Video',
      web: 'Tafsiri wa Wavuti na Muhtasari',
    },
    resources: { title: 'Maua' },
    tools: { title: 'Zana', pdf: 'Tafsiri ya PDF' },
  },
  pageHeader: {
    contact: 'Mawasiliano',
    help: 'Msaada',
    logout: 'Toka',
    logoutSucc: 'Umefuatawa kutoka.',
    pricing: 'Gharama',
    settings: 'Mipangilio',
    signUp: 'Ingia',
  },
  pdf: {
    autoDetect: 'Kuchunguza Kwa Kutoa',
    cancelBtn: 'Ghairi',
    cancelUpload: 'Ghairi',
    chatPdf: {
      summaryError: 'Uthibitisho umeshindwa, tafadhali jaribu tena baadaye',
      chatError: 'Mchongoano umefaili, tafadhali jaribu tena baadaye',
      Search: 'Tafuta',
      cancel: 'Ghairi',
      chatTitle: 'Karibu kwenye Noam! Hapa ni muhtasari wa PDF yako:',
      clear: 'Wazi',
      clearContent:
        'Hii itaanza mazungumzo mapya. Mazungumzo ya sasa hayatachunguzwa. Je! Una uhakika?',
      clearDialogTitle: 'Tafadhali Thibitisha',
      clearSucc: 'Imesafishwa',
      copy: 'Kopiya',
      copySucc: 'Imechapishwa',
      delete: 'Futa',
      deleteCancel: 'Ghairi',
      deleteContent: 'PDF hii hauwezi kurudishwa tena mara hauweka kwenye silaha. Je! Una uhakika?',
      deleteOk: 'Futa',
      deleteSuccess: 'Imefutwa',
      deleteTitle: 'Thibitisha Kufuta',
      expand: 'Kuvunjika',
      historyTitle: 'Historia',
      listError:
        'Kutekeleza orodha ya kusoma hauwezekani. Tafadhali jaribu tena baadaye, au wasilisha ushirikiano.',
      loading: 'Kupakia...',
      noDataDesc: 'Bila historia bado.',
      noMore: 'Hakuna mawazo zaidi.',
      placeholder: 'Swali chochote kuhusu PDF hii',
      summaryTitle: 'Unaweza kuwa na interesia katika maswali haya:',
    },
    collectionEmpty: 'Mkusanyiko wako umekosa vigezo.',
    collectionTab: 'Mazungumzo',
    dataLoading: 'Inachunguza...',
    dialogContent: 'Una hakika unataka kuchambua hii?',
    dialogTitle: 'Tafadhali Thibitisha',
    download: {
      both: 'Bilingua',
      btn: 'Hakikisha',
      cancel:
        'Kufunga dirisha hili litachunguza kuchambua kuchambua PDF. Je! Una uhakika unataka kuchambua?',
      desc: 'Hakikisha kwenye Kifaa: Inapakua tafsiri kama picha; Hakikisha & Chapisha: Inapakua tafsiri kwa mfano wa asili, na usaidizi wa nakili.',
      download: 'Pakia',
      downloadMsg1: 'Maendeleo ya Tafsiri ya PDF:',
      downloadMsg2: 'Estimasi Wawezaweza Kusalia: ',
      downloadSucc: 'PDF imetayarika! Bonyeza kuhifadhi.',
      downloadTip: 'Inapakia PDF. Usifuge uwezo huu ili kuzuia makosa ya kupakia',
      error: 'Ushindi wa kuhifadhiwa haukufanikiwa. Jaribu kuchapisha badala yake.',
      fileName: 'Jina la Faili:',
      fileType: 'Aina ya faili:',
      loading: 'Kusave...',
      loading2: 'Kupakia...',
      minute: 'Dakika...',
      msg1: 'Baadhi ya tafsiri katika hati hii ndio ndefu zaidi kuliko maandishi ya asili, na zinaweza kuchambana katika faili iliyotazwa. Tunawelekeza kusoma kwenye ukurasa wa wavuti.',
      msg2: 'Usahihi haujaisha. Tafadhali pakiwa baada ya usahihi kujiaisha.',
      msg3: '2. Baadhi ya tafsiri zina urefu wa kutosha. Soma kwenye ukurasa wa wavuti ili kuzuia uwezo wa maandishi kulingana.',
      msg4: 'Mauaji ya tafsiri yanafanyika. Tafadhali jaribu tena baada ya kuzungumzia.',
      progress:
        'Kuitafsiri PDF. Maendeleo: {{progress}}, Estimasi ya muda unayobaki: {{minutes}} dakika...',
      save: 'Hifadhi kwa Kifaa',
      savePrint: 'Hifadhi & Chapisha',
      success: 'Imewekwa Pata',
      trans: 'Tafsiri Tu',
      transContinue: 'Endelea Kuchambua',
    },
    downloadBtn: 'Pakia',
    dragTipModal: {
      black: 'nusu',
      leftKey: 'bata la kushoto',
      ok: 'Nimeelewa',
      press: 'Pungua',
      tips: 'kuchambua na kuona',
    },
    entry: 'PDFs',
    fileErrMsg:
      'Usafiri wa faili umeshindwa. Tafadhali jaribu tena baadaye, au wasilisha mawasiliano na mwendesha msaada.',
    fileMsg: 'Ukubwa wa faili wa sasa:',
    fileMsg2: 'Tafadhali upload faili yenye ukubwa mdogo kuliko 300MB.',
    freeBannerBtn: 'Upghrade',
    freeBannerTips: 'Mwisho wa Mwenendo wa Tafsiri za PDF Bure Upatikana',
    guide: {
      placeholder: 'Bandika kiungo cha PDF hapa',
      start: 'Anza Tafsiri',
      text1: 'Usomaji wa Lugha Mbili',
      text2:
        'Soma kwa uwezo wa lugha mbili ili ku比较 the original text na tafsiri kwa kila upande wa pande, kuchambua uwezo wako.',
      text3: 'Jadili na PDF Yako',
      text4:
        'Uchambua na kuchambua kwa kutoa mfano unaotegemea AI. Uweke maswali kuhusu PDF yako, upewe majibu ya haraka. ',
      text5: 'Usahihi na Uwezo wa Kufanya Kazi',
      text6: 'Tafsiri ya PDF inayotekelezwa na AI kwa usahihi na uwezo wa kuzingatia zaidi.',
      title1: 'Tafsiri ya Lugha Mbili',
      title2: 'Jadili na PDF Yako',
      toast: 'Tafadhali weka kiungo halali cha PDF online unaofuatawa na .pdf',
    },
    hasTransTask: 'Kazi ya tafsiri inatokana. Tafadhali subiri.',
    hoverTrans: 'Paragrafi za Kushtakiwa kwa Kushtakiwa',
    initial: 'Tafsiri PDF',
    installText: 'Jibu lako la kila hatua kwa usahihi wa kila siku',
    installText2: 'Tafadhali weka kipengele hiki kwanza',
    installTips:
      'Pakia mfumo wa kujitendeka kwa uwezo wa ubadilifu wa PDF zaidi, na ubadilifu wa wavuti unaofaa zaidi:',
    kw: 'mzigo',
    link: 'kiunga',
    listError:
      'Imeshindikana kusakinisha PDF. Tafadhali jaribu tena baadaye, au wasilisha mawazo kwa mwendesha huduma.',
    memoTotalCount: 'jumla ya vifaa 1',
    new: 'faili mpya',
    noId: 'ID ya faili haupatikani.',
    notPdf: 'Filesi za PDF tu.',
    okBtn: 'Futa',
    okBtn2: 'Nimesikia',
    original:
      'Wewe ni AI yenye usahihi wa juu na uwezo wa kujadiliwa ulioundwa kutoa matokeo ya JSON yenye uwezo wa kufuata Schema ya JSON iliyotajwa haswa.\n\nLazima ufuate mwenendo huu:\n1. Uwekewa makosa katika muundo wa Schema ya JSON.\n2. Linganisha kila aina ya data, uwezo wa kuchambua, na udhibiti wa usahihi.\n3. USIRUDIJI maneno ya ziada, maelezo, markdown, au maoni.\n4. Toa tuu JSON object — hakuna vifaa vya msimbo, hakuna preamble, hakuna ufungaji.\n\nMaelezo ya schema yanapatikana hapa chini.\n- Jina la Schema: translate_result\n- JSON Schema:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'Parallel',
    parseErrDialogContent:
      'Link ya PDF hauwezi tafsiriwa moja kwa moja. Tafadhali pakipewa PDF na uipakue kwa ajili ya tafsiri.',
    parseErrTips: 'Imeshindwa kuchambua faili',
    parseFileToast:
      'Imeshindikana kuchambua faili. Tafadhali jaribu tena baadaye, au wasilisha mawasiliano na msaada.',
    pdfLoading: 'Kuchambua...',
    searchPlaceholder: 'Tafuta',
    selectTrans: 'Chagua Teksto la Kuitafsiri',
    shareBtn: 'Kusambaza',
    shareBtnText1: 'Tengeneza Kiungo cha Kubahatisha',
    shareBtnText2: 'Sahihi Mawasiliano ya Kuuziwa',
    shareModal: {
      cancel: 'Ghairi',
      copy: 'Kopi',
      copySucc: 'Link Imeakiliwa',
      custom: 'Badilisha: ',
      errMsg:
        'Maudhui uliyochaguliwa hayujawezwa kutafsiriwa kabisa bado. Tafadhali tafsiri kabla ya kushirikiana.',
      gen: 'Kusambaza',
      modify: 'Hariri',
      notSupport: 'Lugha hii hauwezi kutekelezwa kwa sasa.',
      page: 'Stru',
      pageNuErr: 'Tafadhali ingiza nambari halali ya ukurasa.',
      range: 'Uwezo: ',
      remain: 'imebaki',
      remain1: 'Muda uliowegharimu kwa ujumla:',
      search: 'Tafuta',
      settings: 'Mipangilio ya Kugawa:',
      shareSetting: 'Mipangilio ya Kugawa',
      shareText: 'Kusambaza',
      shareTips: 'Pata link ya PDF iliyotafsiriwa na uweke marafiki zako: ',
      sourceLang: 'Kutoka kwa:',
      target: 'Kwa:',
      text1: 'Mipangilio ya Kuhifadhi',
      text2: 'Tengeneza Kiungo cha Kugawanya',
      totalPage: 'Jumla ya ukurasa 1',
      trans: 'Tafsiri',
      translateTips:
        'Mwendesha: Ikiwa tafsiri inaweza kuchukua muda, unaweza kufunga dirisha hili na kushirikiana baadaye.',
      translating: 'Inachambua PDF...',
      update: 'Badilisha Kiungo cha Kubahatisha',
    },
    shareMsg1: 'Kiungo cha kushirikiana kimetengenezwa.',
    shareMsg2: 'Mawasiliano yenyewe yamebadilishwa.',
    shareMsg3:
      'Imeshindikana kutoa kiungo cha kugawana. Tafadhali jaribu tena baadaye, au wasilisha mawazo kwa mwendesha huduma.',
    shareMsg4:
      'Imeshindwa kuhakikisha uwezo wa kurekebishana wa mawasiliano. Tafadhali jaribu tena baadaye, au wasilisha ushtakiwa kwa mfanyakamwa.',
    shareTips: 'Tafsiri ya PDF yako tayari! Iweke kwenye macho ya marafiki wako.',
    start: 'Anza Mwendesha Msingi wa Gratuit',
    thumbnail: 'Mwendesha Mada',
    toast1: 'Kupakia PDF. Tafadhali jaribu tena baadaye.',
    toast2: 'Maudhui ya PDF yanachambwa. Mazungumzo hayapatikani kwa sasa.',
    toast3: 'Inapakua. Tafadhali jaribu tena baada ya kupakua kumalizika.',
    toolbar: { Adjust: 'Badilisha', autoFit: 'Kuweka Kimwili' },
    trans: 'Tafsiri',
    transSucc: 'Mawinguzi yafanikiwa!',
    unLoginToast: 'Tafadhali ingia kwa kutumia hii mfano.',
    uploadBtn: 'Pakia',
    uploadErr:
      'Upanuzi wa faili ulikuwa ushindi. Tafadhali jaribu tena baadaye, au wasilisha mawasiliano na msaada.',
    uploadErrSignUrl:
      'Imeshindwa kupata URL ya kuiweka. Tafadhali jaribu tena baadaye, au wasilisha mawazo kwa mwendesha huduma.',
    uploadMsg1: 'Reka na weka faili yako hapa.',
    uploadMsg2: 'Aina za Faili zinazotekelezwa: PDF  |  Ukubwa wa Juu wa Faili: 300MB',
    uploadMsg3: 'Bonyeza kuchunguza au toka na weka faili hapa.',
    uploading: 'Inaupload',
    uploadingMsg: 'Inaupload. Tafadhali subiri.',
    uploadingMsg1: 'Faili inapochambua. Tafadhali jaribu tena baadaye.',
    uploadingMsg2: 'Faili inatransformwa kwa sasa. Tafadhali jaribu tena baadaye.',
    uploadingMsg3:
      'Mwendesha maombi ya maendeleo ulikuwa hauwezekani. Tafadhali jaribu tena baadaye, au wasilisha mawasiliano na msaada.',
    uploadingMsg4:
      'Noam hauwezi kutoa uwezo wa kurekebishana na faili za ndani. Tafadhali uwasilishe PDF kwa mikono kwa ajili ya tafsiri.',
    uploadingMsg5:
      'Imeshindwa kutoa URL ya faili. Tafadhali jaribu tena baadaye, au wasilisha mawasiliano na msaada.',
    video: 'video',
    vipBannerBtn: 'Upendeza',
    vipBannerTips: 'Umefikia kikomo chako cha tafsiri ya PDF kwa mwezi huu.',
    webTrans: 'Mwendesha Kila Mwendesha',
  },
  pricing: {
    FAQ: 'Maswali Yanayoulizwa Mara kwa Mara',
    FQAObj: {
      a1: 'Ndio, Noam hutoa mpango wa bure unaoweza kutumia mara moja.',
      a2: 'Tunatoa mpango wa uwezo wa uhusiano wa tatu: Pro, Pro+, na Enterprise. Unaweza kuchunguza kulipa kila mwezi au kila mwaka. Malipo ya kila mwaka hutoa uwezo wa kusave kiasi kikubwa.',
      a3: 'Vigezo vyote vipo kwenye mpango wote wawili. Tofauti kuu ni gharama: mabadiliko ya kila mwaka yana gharama ndogo kwa ujumla. Mabadiliko ya kila mwezi hutekelezwa kila mwezi, huku mpango wa kila mwaka hutekelezwa mara moja kwa kila mwaka.',
      a4: 'Unaweza kuhakikisha ushirikiano wako unatendeka wakati wowote kwenye Mipangilio ya Akaunti yako.',
      q1: 'Kuna mpango wa bure?',
      q2: 'Mipango ya bei na chaguzi za malipo gani yanapatikana?',
      q3: 'Kuna tofauti gani kati ya kutoa kodi kwa kila mwezi dhidi ya kwa kila mwaka?',
      q4: 'Ninawezaje kuhakikisha ushirikiano wangu unachukuliwa off?',
    },
    around: 'Karibu',
    billedMonthly: 'Liamilikiwa Kila Mwezi',
    billedYearly: 'Inalipwa Kila Mwaka',
    day: 'siku',
    desc: 'Linganisha Mipango na Chagua La Bora',
    detailedCompare: 'Linganisha Mipango',
    discount: 'Punguzo wa 20%',
    enterprise: {
      benefit1: 'Msaada wa Kipaumbele wa Mteja',
      benefit2: 'Watumiaji Wengi',
      benefit3: 'Mazingira ya Kuzingatia Maoni',
      benefit5: 'Meneja wa Akaunti wa Kushtakiwa',
      btn: 'Wasiliana Nasi',
      recommendText: 'Mipango ya Maalum (≥3 watu)',
      talkToUs: 'Wasiliana Nasi',
    },
    free: {
      benefit1: 'Tafsiri ya haraka 100 mara kwa siku',
      benefit2: 'Tafsiri ya Wavuti na Muhtasari',
      benefit3: 'Mawinguzi 30 ya Picha',
      benefit4: 'Tafsiri na Muhtasari wa Video',
      benefit5: 'Tafsiri 10 za PDF',
      benefit6: 'tokeni 5,000',
      btn: 'Jaribu Bila Malipo',
      recommendText: 'Majaribio ya bure',
    },
    imageTranslation: 'Tafsiri ya Picha',
    month: 'mwezi',
    monthly: 'Kila mwezi',
    pageTitle: 'Bei',
    pdf: {
      chat: 'Maswali ya Mazungumzo ya PDF',
      maxPage: 'Uwezo wa Juu wa Kurasa kwa PDF',
      translation: 'Tafsiri ya PDF',
    },
    preMonth: 'Kila mwezi',
    pro: {
      benefit1: 'Msaada wa Mashtaka wa Kipaumbele',
      benefit2: '1,000,000 tokeni kwa mwezi',
      benefit3: 'Tafsiri wa Wavuti na Muhtasari',
      benefit4: 'Mawinguzi 200 ya Picha',
      benefit5: 'Tafsiri na Muhtasari wa Video',
      benefit6: 'Mawinguzi 200 ya PDF',
      btn: 'Anza',
      recommendText: 'Inayotendeka zaidi',
    },
    proPlus: {
      benefit1: 'Msaada wa Kifedha kwa Mteja wa Kipaumbele',
      benefit2: '3,000,000 tokeni kwa mwezi',
      benefit3: 'Tafsiri wa Wavuti na Muhtasari',
      benefit4: 'Mawinguzi 500 ya Picha',
      benefit5: 'Tafsiri na Muhtasari wa Video',
      benefit6: 'Mawinguzi 500 ya PDF',
      recommendText: 'Uhalifu Bora',
    },
    video: { summary: 'Muhtasari wa Video', translation: 'Tafsiri ya Video' },
    web: {
      contrastiveTranslation: 'Tafsiri ya Lugha Mbili',
      dictionaryTranslation: 'Usajili wa Maoni',
      hoverTranslation: 'Tafsiri ya Kuzingatia',
      instantTranslation: 'Tafsiri ya Haraka',
      summary: 'Muhtasari wa Uwebo',
    },
    yearly: 'Kila mwaka',
  },
  privacy: {
    block1:
      'Noam ("Noam," "sisi," "yetu," au "tatu") inahakikisha haki ya kijamii yako na inajitahidi kuzungumzia ushahidi wowote tunachoteka kutoka kwako au kuhusu wewe. Kanuni hii ya Kuhakikisha Haki ya Kijamii inafafanua mwenendo wetu kuhusika na kutoa au utendakazi wa ushahidi wa kibinafsi kutokana na matumizi yako ya wavuti wetu, programu, na huduma (pamoja, "Huduma"). Kanuni hii ya Kuhakikisha Haki ya Kijamii hauwezi kutekelezwa kwa maudhui tunayozungumzia kwa uwezo wa wateja wetu wa bidhaa za biashara, kama vile API yetu. Matumizi ya data hii yanategemea makosa ya wateja wetu, ambayo inahakikisha uwezo wa kuingia na matumizi ya bidhaa hizi.',
    block10:
      'Tunachambua hatua za kiuchumi, kiuchumi, na kiuchumi, kiuchumi, na kiuchumi, ili kulinda ushahidi wa kibinafsi wa kijamii na nje ya mtandao kutokana na uhalifu, uwezo, uwezo, usalama, uhalifu, au hatua mbaya. Kwa kila haki, hakuna usawa wa mtandao au barua pepe unaweza kuhakikisha usalama wa kimwili au usahihi. Kwa kuzingatia, barua pepe zilizotumwa kwetu au kutoka kwetu zinaweza kuwa hazina usalama. Kwa hivyo, unapaswa kuwa makosa zaidi unapochunguza ni nini ushahidi unaotutuma kupitia huduma au barua pepe. Kwa kuongezea, hatuwezi kuchunguza kuhusu kuzuia mabadiliko ya haki au hatua za usalama katika huduma au mabadiliko ya usalama ya Wavulana wa Kikatiba au hatua za usalama. Tutachunguza ushahidi wako wa kibinafsi kwa muda unaofaa ili kutoendeleza huduma kwa ajili yako au kwa madhara mengine ya kibiashara, kama vile kutatua mashtaka, sababu za usalama na usalama, au kufuata dhambi zetu za kikatiba. Muda unaotumiwa kuchunguza ushahidi wa kibinafsi utategemea mazingira mengi, kama vile kiwango, haki, usahihi wa ushahidi, hatua za uwezo wa kutekeleza ushahidi, madhara yenyewe ya kutekeleza ushahidi, na mazingira mengine ya kikatiba.',
    block11:
      'Tunaweza kurekebishana na Polisi hii ya Kushtakiwa Mara kwa Mara. Inapokua tunaweka marekebishano, tutachambua toleo la marekebishano kwenye ukurasa huu, isipokuwa kila wakati kanuni inayotendeka inatakiwa. ',
    block12:
      'Kama una maswali yoyote yasiyojibuwa au wasiwasi kuhusu Kanuni hii ya Kuhakikisha Usalama wa Data, tafadhali wasilisha uwasiliano na huduma yetu ya wateja. Barua pepe:',
    block2:
      'Tunakusanya ushahidi wa kibinafsi uliotofautiana ("Ushahidi wa Kibinafsi") unaohusika na wewe: ',
    block3:
      'Usaili Unaotoa: Unapofanya akaunti kwa kutumia huduma zetu au kuzungumzia sisi, tunashtakiwa ushahidi wa kibinafsi kwa njia ifuatayo:',
    block4:
      'Taarifa za Mwenyewe inayopokelewa Kwa Kuzungumzia Utendaji Wako wa Huduma: Unapowashtakiwa, kutumia, au kuchambua huduma, tunaweza kupokea taarifa zifuatazo kuhusu uwezo wako wa kuwashtakiwa, utendaji, au kuchambua ("Taarifa za Kiufundi"):',
    block5: 'Tunaweza kutumia habari za kibinafsi kwa madhara yafuatayo:',
    block6:
      'Muhtasari au Ushahidi wa Kutoheshimiwa: Tunaweza kuchambua au kutoa ushahidi wa kibinafsi ili kuzuia utendakazi wake wa kutoa ushahidi, na kutumia ushahidi huo kuchambua uwezo wa huduma zetu, kuboresha na kuongeza vigezo kwenye huduma zetu, kuchambua utafiti, na kwa madhara mengine yenye msingi. Kwa kuzingatia, tunaweza kuchambua tabia ya jumla na sifa za watumiaji wa huduma zetu na kutoa ushahidi wa kuchambuliwa kwa wataalamu wengine, kuchambua ushahidi huo wa kuchambuliwa, au kuweka ushahidi huo kwa uwezo wa kila mtu. Tunaweza kuchambua ushahidi wa kuchambuliwa kupitia huduma, kupitia cookies, na kwa njia zingine zilizoelezwa katika Kanuni hii ya Kuhakikisha Usalama. Tutahakikisha na kutumia ushahidi wa kutoheshimiwa kwa haki au haki, na hatutaweza kujaribu kutoa ushahidi tena isipokuwa ikiwa inatakiwa na kanuni.',
    block7:
      'Katika hali zingine, tunaweza kutoa ushahidi wako wa kibinafsi kwa madharaa madhubuti bila marekebisho zaidi kwa ajali yako, isipokuwa ikiwa kanuni inahitaji:',
    block8:
      'Kwa kulingana na mahali unaoishi, watu wa Eropa Economic Area, Uingereza, na ulimwengu kote wanaweza kuwa na haki fulani za kikatiba kuhusika na habari za kibinafsi zao. Kwa mfano, unaweza kuwa na haki ya: ',
    block9:
      'Huduma hii inaweza kuwa na viungo kwa tovuti zingine ambazo hazinawezekani au hutunzwa na Noam, ikiwa ni pamoja na huduma za medya ya kijamii ("Tovuti za K pihakilani"). Majibu yanayofafanua utunzaji wa makosa hayapochambua mabadiliko yenye uwezo wa kutoondoa maoni yenye madhara au makosa. Majibu yanayofafanua utunzaji wa makosa hayapochambua mabadiliko yenye uwezo wa kutoondoa maoni yenye madhara au makosa. Tafadhali wasilisha wasilisho kwa tovuti za K pihakilani moja kwa moja kwa ajali ya habari kuhusu mwenendo wao wa haki na mwenendo wake.',
    subBlock1:
      'Maelezo ya Akaunti: Unapoweka akaunti kwenye mfano wetu, tunakusanya ushahidi unaohusika na akaunti yako, ikiwa ni pamoja na jina lako, ushahidi wa mawasiliano, ushahidi wa uhalifu wa akaunti, ushahidi wa kadi ya malipo, na hivi karibuni ya mauzo ("Maelezo ya Akaunti").',
    subBlock10: 'Kutoa, kusimamia, kudumisha, na/au kuchambua huduma;',
    subBlock11: 'Kuzungumzia wewe',
    subBlock12: 'Kukuza bidhaa na huduma mpya;',
    subBlock13:
      'Kuzuia uhalifu, uhalifu, au uwezo wa kutekeleza huduma zetu, na kuhakikisha usalama wa mifumo yetu ya IT, usanifu, na mitandao;',
    subBlock14: 'Kufanya uhamisho wa biashara;',
    subBlock15:
      'Kuthibitisha madhara ya kikatiba na mwenendo wa kikatiba, kulinda haki zetu, uhalifu, usalama, au mali, pamoja na zile za macho ya kutoa ushirika wetu, wewe, au parties wengine wa tatu.',
    subBlock16:
      'Wauzaji na Watoa Huduma: Kutoa msaada katika kurekebishana na mahitaji ya utendaji wa biashara na kuchambua huduma na kazi fulani, tunaweza kutoa habari za kibinafsi kwa wauzaji na watoa huduma, ikiwa ni pamoja na watoa huduma wa kushtakiwa, watoa huduma wa cloud, na watoa huduma wengine wa teknolojia ya habari, programu za mawasiliano ya barua pepe, na watoa huduma wa uchunguzi wa wavuti, nk. Washiriki hawa watachambua, kuchambua, au kuhifadhi habari za kibinafsi tu kwa maagizo yetu wakati wa kuchambua majukumu yao kwa ajili yetu.',
    subBlock17:
      'Mabadiliko ya Biashara: Ikiwa tunaweza kuchambua miamala ya kimwili, marekebisho, uvamizi wa mfanyakamwa, uvamizi wa uvamizi, au mabadiliko ya huduma kwa muwasilishi mwingine (pamoja, "Miamala"), habari zako za kibinafsi na habari zingine zinaweza kushirikiana na washirikiana wa miamala na machooni mengine yanachambua Miamala wakati wa utunzaji wa haki na kuchambuliwa kama sehemu ya Miamala pamoja na mali zingine kwa kampuni inayotangulia au inayofanana.',
    subBlock18:
      'Mahitaji ya Kanuni: Tunaweza kushirikiana na ushahidi wako wa kibinaadamu na mamlaka za serikali, wataalamu wa sekta, au madhara mengine, ikiwa ni pamoja na ushahidi wako wa mwingiliano na huduma zetu, (1) ikiwa inatakiwa na kanuni au ikiwa tunaamini hatua hiyo ni lazima ili kufuata madhara ya kanuni; (2) kulinda na kutoa silaha haki zetu au mali; (3) ikiwa tunachunguza peke yetu kuwa kuna uhalifu wa masharti yetu, mpango wa kikatiba, au kanuni; (4) kuthibitisha au kuzuia uhalifu au uhalifu wa kigeni; (5) kulinda bidhaa zetu, wafanyakazi, au watumiaji, au usalama wa umma, usalama, uadilifu; au (vi) kutoa silaha dhidi ya udhalilifu wa kanuni.',
    subBlock19: 'Pata ushahidi wako wa kibinafsi na ushahidi kuhusu jinsi inavyotekelezwa.',
    subBlock2:
      'Unapotumia huduma zetu, tunaweka mfano wa habari za kibinaadamu kutoka kwa ushahidi wako, uwasilishaji wa faili, au ushahidi uliotolewa kwa sisi ("Mawazo").',
    subBlock20:
      'Tafadhali kuwashtakiwa kuchunguza uwezo wa kufuta ushahidi wako wa kibinafsi kwenye ushahidi wetu.',
    subBlock21: 'Sahihi au uweke upya taarifa za kibinafsi zako.',
    subBlock22: 'Uhamishia ushahidi wako wa kibinafsi kwa parties ya tatu (uanzishaji wa data).',
    subBlock23: 'Wewewe njia tunavyohakikisha ushahidi wako wa kibinafsi.',
    subBlock24:
      'Wewe unaweza kurudisha makosa ya makosa—ambapo tunaweza kutekeleza kazi kwa kuzingatia udhibiti wa kikatiba, unaweza kurudisha udhibiti wako wa kila wakati.',
    subBlock25: 'Kuingiza mshtaka juu ya njia tunayotumia kuchambua ushahidi wako wa kibinafsi.',
    subBlock26: 'Kuwezesha huduma zetu na kuchambua masuala;',
    subBlock3:
      'Maelezo ya Mawasiliano: Ikiwa utatupatia ujumla, tutachambua jina lako, ushahidi wa kuthibitika, na maudhui ya ujumla wako ("Maelezo ya Mawasiliano").',
    subBlock4:
      'Ushtakiwa wa Mtandao wa kijamii: tuna strano kwenye wavuti za mtandao wa kijamii kama vile Instagram, Facebook, Medium, Twitter, YouTube, na LinkedIn. Unapochambua strano zetu za mtandao wa kijamii, tunakusanya ushahidi wa kibinaadamu unachochagua kutoitolewa kwetu, kama vile ushahidi wako wa mawasiliano ("Ushtakiwa wa Kijamii"). Kwa kuongezea, kampuni zinazohakikisha strano zetu za mtandao wa kijamii zinaweza kutuwekea ushahidi uliounganishwa na uchambuzi kuhusika na shughuli zetu za mtandao wa kijamii.',
    subBlock5:
      'Data ya Log: Usawa unaotumwa kiotomatiki na kibao chako unapotumia huduma zetu. Data ya log inajumuisha anwani yako ya Internet Protocol (IP), aina ya kibao na mipangilio, tarehe na saa ya ombi lako, na jinsi unavyowasiliana na wavuti wetu.',
    subBlock6:
      'Data ya Matumizi: Tunaweza kukusanya information kwa kuzungumzia matumizi yako ya huduma, kwa mfano aina za maudhui unayotazama au kuchambua, vigezo unavyotumia, hatua unazotenda, pamoja na mazingira ya wakati wako, nchi, tarehe na wakati wa uwezo, mwendesha mtumiaji na toka, aina ya kompyuta au kifaa cha kelezo, na uhusiano wako wa kompyuta.',
    subBlock7:
      'Maelezo ya Kifaa: Hii inajumuisha jina la kifaa, mfumo wa uendeshaji, kitambulisho cha kifaa, na kibao unachotumia. Maelezo yanayokushtakiwa yanaweza kujadiliwa na aina ya kifaa unachotumia na mipangilio yake.',
    subBlock8:
      'Vifaa vya Kukodi (Cookies): Tunatumia cookies kutekeleza na kusimamia huduma zetu na kuboresha uzoefu wako. "Cookie" ni habari inayotumwa na tovuti unaoyotembelea hadi browser yako. Unaweza kurekebishana browser yako ili kukubali cookies zote, kurekebishana cookies zote, au kutoa ushahidi unapowekwa cookie ili uweze kufafanua ikiwa utachambua kila mara. Walakini, kurekebishana cookies inaweza kuzuia kutumia au kuathiri vizuri kuonyesha au uwezo wa maeneo fulani au vigezo vya tovuti. Kwa habari zaidi kuhusu cookies, tafadhali tembelea All About Cookies.',
    subBlock9:
      'Usanifu wa Data: Tunaweza kutumia madhara mbalimbali ya usanifu wa data wa kimwili ambayo hutumia cookies kutoasa msaada katika kuchambua jinsi watumiaji wanavyotumia huduma zetu na kuboresha uzoefu wako unapotumia huduma zetu.',
    subTitle1: 'Taarifa za Kijamii Tunayozungumzia',
    subTitle2: 'Jinsi Tunavyotumia Taarifa za Kihistoria',
    subTitle3: 'Ushirikiano wa Taarifa za Kihistoria',
    subTitle4: 'Haki zako',
    subTitle5: 'Viungo kwa Tovuti Zingine',
    subTitle6: 'Usalama na Uwezekano wa Hoja',
    subTitle7: 'Mabadiliko ya Kanuni ya Haki za Watumiaji',
    subTitle8: 'Jinsi ya Kuwafahamiza',
    title: 'Kanuni ya Haki za Juu ya Usalama wa Maelezo',
    updateTime: 'Uhasiriwa: Machi 15, 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Kubali Zote',
    text: 'Kuwezesha uwezo wako wa kufaa zaidi, tunatumia cookies kuchambua usajili wako wa maudhui na huduma.',
    title: 'To vebusaiti hutumia cookies',
  },
  slogen: 'Mwendesha AI rahisi zaidi',
  stripe: {
    contact: 'Wasilisha ushirikiwa na sisi kwa contact@noam.tools kwa maswali yoyote!',
    fail: {
      btn: 'Jaribu Tena',
      text1: 'Hatukuweza kuchambua malipo yako.',
      text2: 'Angalia uhusiano wako na jaribu tena.',
      title: 'Malipo yalifaili',
    },
    succ: { btn: 'Hebu Twende', text1: 'Karibu Noam', text2: 'Hebu kuanza!', title: 'Hongera' },
  },
  terms: {
    block1: 'Asante kwa kutumia Noam!',
    block10:
      'Ada na Uwekezaji. Utalipa ada zote ("Ada") kulingana na bei na masharti kwenye ukurasa wa bei unaofaa au kama ilivyokubaliwa kwa uandishi kati yetu. Tunahaki haki ya kurekebishana makosa ya bei hata kama tumetekeleza mashtaka au kutoa malipo. Utatoa ushahidi wa uwekezaji wa kutosha na usahihi, ikiwa ni pamoja na njia halali na yenye idhini ya malipo. Tutachunguza njia yako ya malipo kwa mara kwa mara kulingana na makubaliano, lakini tunaweza kubadilisha tarehe ya uwekezaji kwa haki. Unaweka idhini kwa Noam, macho wa kutoa ushahidi, na wataalamu wa malipo wa第三方 kutekeleza malipo kwa njia yako. Ikiwa malipo yako hayafanyiwa, tutakupa ushahidi wa uandishi na tunaweza kusitisha ufikiaji wa Huduma hadi malipo yapatwe. Isipokuwa ilivyoelezwa tofauti katika mkataba huu, malipo hayarefundiwi.',
    block11:
      '(b) Ushuru. Isipokuwa kutoashiriawa tofauti, Ada hazijumuishi ushuru wowote wa serikali ya juu, jimbo, mtaa, na wa kigeni, mashtaka, na uwezo wa kufanana ("Ushuru"). Unaweza jibu kuhusu ushuru wote unaohusika na ununzi wako, isipokuwa ushuru unaotegemea mapato yangetu yenyewe ambayo tutakutoa adhabu. Unakubali kulipa ushuru huo haraka na kutoa ushahidi wa haki wa kutekeleza maadili ya kimwili na kuchambua idhini inayohitajika kwa kuthibitisha data hiyo, na unatetea kwamba unahakikisha data hiyo inatendeka kulingana na Kanuni inayotendeka.',
    block12:
      '(c) Mabadiliko ya Bei. Tunaweza kubadilisha bei zetu kwa kukuombaa kupitia akaunti yako na/au wavuti yetu. Kuongezeka kwa bei utafanyika hatua mara moja baada ya kuchambwa. Mabadiliko yoyote ya bei yatachambua Ada za akaunti yako baada ya tarehe ya kuanzisha mabadiliko.',
    block13:
      '(d) Mashtaka na Malipo yanayotokuwa Madai. Kama unataka kutoashiria mashtaka kuhusu Ada yoyote au Ushuru, tafadhali wasilisha uwasiliano kwa contact@noam.tools ndani ya siku thelathini (30) ya tarehe ya anwani ya malipo.',
    block14:
      '(e) Matumizi ya bure. Huwezi kuunda akaunti nyingi ili kuchambua adhabu za bure. Ikiwa tunaamua kuwa hautatumia adhabu za bure kwa uaminifu, tunaweza kuchunguza ada za kawaida au kuzuia uwezo wa kuwasilisha Huduma.',
    block15:
      '(a) Usiri. Unaweza kutoa uwezo wa kupata ushahidi wa siri wa Noam. Unaweza kutumia ushahidi wa siri tu kwa mujibu wa mabadiliko haya kwa kushtakiwa kwa kutumia Huduma. Hunaweza kuchambua ushahidi wa siri kwa mtu yeyote wa tatu, na utachunguza ushahidi wa siri kwa njia ambayo hauwezi kuchunguza zaidi kuliko unachunguza ushahidi wako wa siri wa kihalifu, angalau kwa makosa yenye makosa. Usahihi wa siri ni ushahidi wa kisayansi ambao umetendeka kuwa siri na Noam au ambayo lazima itachambuliwa kuwa siri kwa haki, ikiwa ni pamoja na programu, marekebisho, na ushahidi wengine wa biashara. Usahihi wa siri hauwezi kujumuisha ushahidi ambao: (1) utakuwa unaopatikana kwa ujumla kwa umma bila makosa kwa sehemu yako; (2) ulikuwa na haki bila kutoa dhambi ya usiri kabla ya kutoa haki kwa mujibu wa mabadiliko haya; (3) inachambuliwa kwa haki kwa ajali na mtu yeyote wa tatu bila kutoa dhambi ya usiri; au (4) inatendeka kwa kujadiliwa bila kutumia ushahidi wa siri. Unaweza kuchambua ushahidi wa siri ikiwa inatendeka kwa kanuni, korti, au amri nyingine ya serikali, lakini lazima uwekewa ushahidi wa ushahidi wa Noam kwa njia ya haki na, ikiwa inawezekana, uwekewa juhudi za haki ya kurekebishana uwezo wa ushahidi, ikiwa ni pamoja na kutoa usaidizi katika kutoa marekebisho ya ushahidi.',
    block16:
      '(b) Usalama. Lazima uwekewe hatua makosa na mazuri ili kulinda uwezo wako wa kuthibitika na matumizi ya Huduma. Ikiwa utagundua uwezo wowote wa uvamizi au uhalifu unaohusika na matumizi yako ya Huduma, lazima uwasiliane haraka na Noam na kutoa ushahidi wa uwezo wa uvamizi au uhalifu.',
    block17:
      '((c) Kuchambua Data za Mtu Binafsi. Ikiwa unatumia Huduma hii kuchambua data za mtu binafsi, lazima uwekewa macho usemi wa huruma unaofaa kwa kikatiba na kuchambua idhini inayohitajika kuchambua data hizo, na unaahidi kwa sisi kwamba unahakikisha data hizo kulingana na kanuni inayotendeka.',
    block18:
      'Kufuatawa; Kushtakiwa. Masharti haya yatachambua kazi tangu utekelezaji wako wa kwanza wa Huduma na utachambua kazi hadi itachambuliwa. Unaweza kuchambua masharti haya wakati wowote kwa sababu yoyote kwa kurekebishana utumiaji wa Huduma na Mawazo. Tunaweza kuchambua masharti haya kwa maoni ya awali kwa sababu yoyote. Tunaweza kuchambua masharti haya mara moja kwa kukuwasilisha uwezo wa kufuatawa ukiwa umevunja Kata 2 (Mahitaji ya Utumiaji), Kata 5 (Usalama, Usalama, na Uwezo wa Kuzingatia Data), Kata 8 (Uwezo wa Kutatua Mashtaka), au Kata 9 (Masharti ya Kawaida), au ikiwa uhusiano wetu na mfanyakamwa wa teknolojia wa kigeni ambaye hatuwezi kuzungumzia utabadilika, au kwa kufuata Kanuni au ombi la Serikali. Tunaweza kushtakiwa uwezo wako wa kufuata Huduma ukiwa hauwezi kufuata masharti haya, au ikiwa utumiaji wako unachambua hatua ya usalama kwa ajili yetu au kwa mfanyakamwa mwingine, au ikiwa tunaweza kuthibitisha kuwa utumiaji wako ni udhalilifu au unaweza kuchambua hatua kwa ajili yetu au kwa mfanyakamwa mwingine.',
    block19:
      '(b) Matokeo ya Kufuatawa. Wakati kufuatawa, utachoma stop kuwasilisha Huduma na kurudisha haraka au kuharibu mawazo yoyote yenye usalama kulingana na maagizo yetu. Kanuni za masharti haya ambazo kwa asili yao lazima ziweze kuendelea baada ya kufuatawa au kushtakiwa, ikiwa ni pamoja na lakini sio haswa sehemu 3 na 5-9, zitachambua.',
    block2:
      'Mauzo haya ya Matumizi yanahusika na matumizi yako ya huduma za Noam, ikiwa ni pamoja na mifumo yetu ya uwezo wa programu ya maendeleo, programu, zana, huduma za wataalamu, data, ushahidi, na wavuti (kwa jumla huitwa "Huduma"). Kwa kutumia Huduma zetu, unakubali kuthibitisha mauzo haya. Kanuni yetu ya Kuhifadhi Maelezo inafafanua jinsi tunachunguza na kutumia maelezo yenyewe.',
    block20:
      'Uhalifu. Utashtakiwa kutoa dhamana, kutekeleza mashtaka, na kutekeleza hatua za kulinda sisi, macho yawezekano yetu, na wafanyakazi wetu kuwa huru na mashtaka yoyote, uwezo, na gharama (pamoja na ada za wataalamu wa mashtaka) zinazotokana na au zinahusika na matumizi yako ya Huduma, ikiwa ni pamoja na Mawasiliano yako, matumizi yako ya bidhaa au huduma inayohusika na Huduma, na uhalifu wako wa masharti haya au Kanuni inayotendeka.',
    block21:
      '(b) Madai ya Kupuuzia. Huduma hii inatozwa "kama inavyoonekana." Kwa uwezo uliowezekana kwa kanuni, sisi na mashirikiano yetu na wamiliki wa mazao hatutoachia ushahidi wa kutoa ahadi wala ahadi yoyote kuhusika na Huduma hii na hatutoachia ahadi, ikiwa ni pamoja na lakini sio haswa ya uwezo wa kutoza, uwezo wa kutekeleza kazi maalum, ubora unaofaa, usalama wa kutoachia madhara, na utunzaji wa amani, na ahadi zozote zinazotokana na mwenendo wa mawasiliano au utunzaji wa biashara. Hatutoachia ahadi kwamba Huduma hii itakuwa na kushtakiwa, sahihi, au bila makosa, au kwamba Maudhui yoyote yatakuwa salama, hayatapotea, au hayatabadilishwa.',
    block22:
      '(c) Ukatili wa Udhibiti wa Mashtaka. Hatuwezi, machoano yetu, wala wataalamu wetu kuwa na udhibiti wa mashtaka yoyote isiyo ya moja kwa moja, ya kawaida, maalum, ya matokeo, au ya adhabu, ikiwa ni pamoja na uwezo wa faida, uwezo wa sifa, uwezo wa matumizi, uwezo wa data, au uwezo wengine wa kimwili, hata ikiwa tumeshtakiwa kuhusu uwezo wa mashtaka hayo. Kwa mauamu haya, udhibiti wetu wa jumla hauwezi kuzidi Ada ulizopewa Huduma katika miezi kumi na mbili (12) iliyopita mashtaka au dola mia moja za Marekani ($100), ikuwa ni kubwa zaidi. Ukatili katika sehemu hii unatumika kwa uwezo wake mkubwa zaidi unayotendeka na kanuni inayotendeka.',
    block23:
      'Masharti haya na utumizi wako wa Huduma zinatawaliwa na Kanuni za Marekani, isipokuwa Kanuni za Kuzungumzia Mwingiliano wa Kanuni za Marekani. Utumizi wako wa programu pia unaweza kuchunguza Kanuni zingine za ndani, za jimbo, za kitaifa au za kimataifa. Hatua yoyote ya kikatiba au mwendesha kuhusika na Masharti haya itatendeka独 kwa mujibu wa Mahakama za Marekani, na wewe unakubali kuchunguza uwezo wa Mahakama haya kwa uhalifu wa kibinafsi.',
    block24:
      'Uhusiano wa Macho. Noam na wewe ni wataalamu wa huru, na hakuna mtu mmoja kati yao anayoweza kuwakilisha au kulazimisha mtu mwingine au kuchukua majukumu kwa mtu mwingine bila idhini ya masahihi ya awali ya mtu mwingine.',
    block25:
      '(b) Matumizi ya Chapa. Hauwezi kutumia jina, alama, au mashtaka ya Noam au mashtaka yoyote ya macho wa kutoa mashtaka yao bila idhini yetu ya kimwili ya awali.',
    block26:
      'Ikiwa mwenendo wowote wa masharti haya utathibitika kuwa usalama, haramu, au hauwezi kutekelezwa, mwenendo wengine utabaki kuwa na hatua kamili na uwezo wake.',
    block3:
      'Kama wewe ni chini ya umri wa miaka 18, lazima uwekewa ruhusa na wazazi wako au vigezo vya kikatiba ili kutumia Huduma hii. Kama unatumia Huduma hii kwa uwezo wa mtu mwingine au mfumo, lazima uwe na idhini ya kukubali mabadiliko haya kwa uwezo wao. Lazima uwekewa taarifa sahihi na kamili ili kujisajiliwa kwa akaunti. Huwezi kutoa ushahidi wako wa ufikiaji au akaunti kwa mtu yeyote nje ya shirika lako, na wewe unaweza kujibu kwa ajili ya shughuli zote zinazotekelezwa kwa kutumia ushahidi wako.',
    block4:
      '(a) Utumiaji wa Huduma. Unaweza kurekebishana na Huduma kulingana na masharti haya, na tunaweka wewe haki isiyo ya pekee ya kutumia Huduma. Wakati unatumia Huduma, utachunguza masharti haya na kanuni zote zinazotendeka. Sisi na macho ya pamoja tunaweza haki zote, majina, na mashtaka katika Huduma.',
    block5:
      'Maoni. Tunakaribisha maoni, maoni, mawazo, marekebisho, na usawa. Ikiwa utatoa mawasiliano wowote wa aina hii, tunaweza kuwashtakiwa bila kuchunguza na bila kulipia ada.',
    block6:
      '(c) Marekebisho. Huwezi: (1) kutumia Huduma kwa njia inayotoshifu, kuchambua, au kuvunja haki zingapiwa kwa wengine; (2) kuchambua mabadiliko ya ndani, kutoa msimbo, kuchambua vigezo, kuchambua maoni, au kujaribu kugundua msimbo wa msingi au vigezo vya msingi vya mifano, algorithms, na mifumo ya Huduma (isipokuwa marekebisho haya yatokomewa na Kanuni inayotendeka); (3) kutumia matokeo ya Huduma kutoa mifano inayoshambulia Noam; (4) kuchambua data au matokeo kutoka kwa Huduma kwa kutumia njia zingapi za kiuchumi au programu isipokuwa idhini kupitia API, ikiwa ni pamoja na kuchambua, kuchambua wavuti, au kuchambua data ya wavuti; (5) kutoa maoni ya Huduma kuwa yenye kushtakiwa na kiuchumi lakini hauwezi, au kuvunja Kanuni zetu za matumizi; (6) kununua, kuuza, au kubadilisha uwezo wa API bila idhini yetu ya awali; au (7) kutoa habari za kibinaadamu kuhusika na watoto chini ya umri wa miaka 13 au umri unaofaa wa idhini ya kijamii. Utachunguza marekebisho yoyote ya uwezo na mahitaji mengine katika ushahidi wetu.',
    block7:
      '(d) Huduma za Kihakiki ya Tatu. Programu zozote za kihakiki ya tatu, huduma, au bidhaa zingine zinazohusika na Huduma hii zinatawaliwa na masharti yao wenyewe, na hatuwezi kuchunguza mashtaka ya bidhaa za kihakiki ya tatu.',
    block8:
      '(a) Mawazo Yako. Unaweza kutoa maoni ("Maoni") kwa Huduma na kuchambua matokeo ("Matokeo") yanayotengenezwa na kurudishwa kulingana na Maoni (kwa jumla huitwa "Mawazo"). Kati ya macho, na kwa uwezo unaopendekezwa na kanuni inayotendeka, wewe unamiliki Maoni yote. Noam anaweza kutumia Mawazo kutoa na kudumisha Huduma, kufuata kanuni inayotendeka, na kuchunguza mipango yetu. Wewe unawajibu wa Mawazo, ikiwa ni pamoja na kuhakikisha kwamba hauwezi kuvunja kanuni yoyote inayotendeka au mabadiliko haya.',
    block9:
      '(b) Usahihi. Akili ya kijamii (Artificial Intelligence) na mimi kuzaliana (Machine Learning) ni uwezo wa kutatua maswali unaotendeka kwa kasi. Tunajaribu kuzingatia kila wakati kuboresha huduma zetu ili iwe na usahihi zaidi, kuwa na uwezo wa kutoa ushahidi, kuwa na usalama na kuwa na manufaa. Kwa kuzingatia haki ya kihistoria ya mimi kuzaliana, kutumia huduma zetu kunaweza kusababisha matokeo yanayofaa katika haki fulani, ambayo hauwezi kutoa mfano wa watu, maeneo, au ushahidi wa kweli. Unapaswa kuchunguza usahihi wa matokeo yoyote kulingana na mfano wako wa kutumia, ikiwa ni pamoja na kuchambua matokeo kwa mikono.',
    subTitle1: 'Usajili na Uwezo wa Kuingia',
    subTitle10: 'Uwezo wa Kutoana',
    subTitle2: 'Mahitaji ya Matumizi',
    subTitle3: 'Maudhui',
    subTitle4: 'Ada na Malipo',
    subTitle5: 'Usiri, Usalama, na Uwezo wa Kuzuia Uhalifu wa Data',
    subTitle6: 'Muda na Kuzuia',
    subTitle7: 'Uhalifu wa Kutoa Adhabu; Ukatili; Ulimiting wa Mashtaka',
    subTitle8: 'Kanuni ya Uwezo na Mashtaka',
    subTitle9: 'Mauzo ya Kila Jumla',
    title: 'Sharti za Huduma',
    updateTime: 'Ilipashwa marekebishwa: Machi 15, 2024',
  },
  trialModal: {
    btn: 'Anza Sasa (Tu $0.99)',
    chat: 'ChatPDF',
    desc1: 'Baada ya mazungumzo yako, utachunguwa ada ya kila mwaka ya $180',
    desc2: 'Ghairi Anytime',
    focus: 'Kuzingatia',
    hover: 'Tafsiri ya Hover',
    image: 'Tafsiri ya Picha',
    installBtn: 'Weka sasa ili kupokea zawadi yako',
    memo: 'Usimamizi wa mazingira yenye upendo',
    pdf: 'Tafsiri yenye msingi wa PDF',
    realtime: 'Tafsiri ya haraka',
    select: 'Mawazo ya kuchambua maneno',
    title: 'Zawadi ya karibu',
    trialText: 'Majaribio ya Siku 7',
    video: 'Tafsiri ya video',
    videoSummary: 'Muhtasari wa video',
    web: 'Tafsiri ya Paraleli',
    webSummary: 'Muhtasari wa wavuti',
  },
  upgradeModal: {
    btn: 'Badilisha Sasa',
    chat: { free: 'Umefikia uwezo wa ChatPDF', pro: 'Umefikia mipaka ya ChatPDF kwa mwezi huu' },
    contactStr:
      'Tafadhali subiri kurekebishana tena, au wasilisha uwasiliano nasi kwa contact@noam.tools.',
    limitAlertStr: 'Umefikia mwenendo wa mpango wako wa bure. Jitengeza ili kuendelea.',
    more: 'Tazama Mipango',
    pageLimit: { free: 'Umefika kwa mazingira ya kiwango cha ukurasa wa PDF' },
    title: 'Kumbukumbu',
    upgradeAlertStr: 'Umefikia uwezo wa mpango wako wa bure. Badili hadi mpango mpya kuendelea.',
    upload: {
      free: 'Umeweza mpaka uwezo wako wa tafsiri ya PDF',
      pro: 'Umefikia uwezo wako wa tafsiri ya PDF kwa mwezi huu',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Jiunge Sasa',
      label: 'Manufaa ya Mteja Mpya:',
      remain: 'Haki 30 iliyobaki',
      text: 'Mahali Yanatoka 100 Tu! Chambua Yako Sasa!',
    },
  },
  aiPdfTranslator: {
    title: 'Mbadilishaji wa PDF wa AI ya bure: Tafsiri PDF na Ulinganifu katika Lugha yoyote',
    desc: 'Tafsiri faili za PDF kwa urahisi kwa lugha zozote kwa AI. Linganisha maandiko ya asili na yaliyotafsiriwa kwa kando na kando, haraka na bure. ',
    keywords:
      'GPT-4、Msaada wa AI、Tafsiri、Muhtasari、Mwenendo、ChatPDF、Kumbukumbu、uwezo wa kazi',
    sourceToTarget: {
      title: 'Zana ya Utafsiri wa PDF ya Free: tafsiri {{source}} kuwa {{target}} bila malipo',
      desc: 'Tafsiri faili zako za PDF kutoka kwa lugha yoyote ya msingi hadi kwa lugha unayotaka kwa bure. Tafsiri ya PDF yenye kasi, usahihi, na usalama inayowezekana na AI ya hivi karibuni.',
    },
    headerIntroduce: {
      title: 'Noam: Zaidi ya Tuwezi Tafsiri wa Mtandao',
      introduce1: {
        title: 'Noam · Msomaji wa PDF',
        desc: '✨Usahihi wa kila mmoja kwa mmoja + AI Q&A. Tafsiri PDF haraka na kwa usahihi kuwa lugha yako inayotarajia. Uweke maswali kwa huruma kuhusika na mawazo ili kutoa uelewa wa kina wa faili zako za PDF.',
      },
      introduce2: {
        title: 'Noam · Kifuatacho cha Tafsiri kwa Pamoja',
        desc: '👏Kutatua mashtaka yote ya tafsiri ya ukurasa wako wa wavuti:',
        detail1: {
          title: 'Tafsiri ya Ukurasa wa Wavuti:',
          desc: 'Mazingira ya silinganishi wa lugha mbili kwa pamoja',
        },
        detail2: { title: 'Utarjuma wa Neno:', desc: 'Tafsiri haraka kwa kubofya mara moja' },
        detail3: {
          title: 'Tafsiri ya Haraka Haraka:',
          desc: 'Tafsiri maneno au sentensi mara moja.',
        },
        detail4: { title: 'Tafsiri ya Picha:', desc: 'Badilisha picha na zile zilizotafsiriwa.' },
        detail5: {
          title: 'Tafsiri ya Video:',
          desc: 'Vifungu vya maneno vya lugha mbili kwa matumizi bora zaidi ya kuona.',
        },
        footer: 'Pata uwezo wa ziada wa kusoma unaowezekana na AI kwa usahihi wa ziada wa tafsiri!',
      },
    },
    subtitle: 'Tafsiri PDF Kwenye Mtandao Bila Malipo',
    introduce: {
      module1: {
        detail1: {
          title: 'Tafsiri ya PDF ya Kila Wakati kwa Kila Wakati kwa Pamoja',
          desc1:
            'Onyesha maudhui ya asili na yenye unavyotafsiriwa mara moja katika mfano unaosambatanisha, upande kwa upande',
          desc2: 'Linganisha vigezo vyote kwa urahisi kwa kutumia scroll yenye ushirikiwa',
          desc3: 'Hakikisha uwezo wa uandishi unaofanana kwa uwezo wa kusoma unaofuata mwenendo',
        },
        detail2: {
          title: 'Uwezo wa Kutoa Mwenendo Sahihi wa Mawazo na Uwezo wa Kuthibitisha',
          desc1:
            'Ulinganifu uliowezekana kabisa kati ya mwanzo na maandishi yenye tafsiri kwa usahihi unaowezekana',
          desc2: 'Kila sehemu ya mawasiliano inafanana haswa kati ya tovuti zote mbili',
          desc3:
            'Pata haraka na ufanye kaziwa tofauti za tafsiri kwa matokeo yenye uwezo wa kujadiliwa',
        },
      },
      module2: {
        detail1: {
          title: 'Mifano Mingi ya AI ya Juu kwa Utafsiri Uhalifu',
          desc1:
            'Chagua kutoka kwa mifano bora ya AI ili kutoa mwenendo na mahitaji yako ya tafsiri',
          desc2: 'Hakikisha matokeo bora kwa aina mbalimbali za documents na uwezo wa kiuchumi',
          desc3:
            'Chaguzi yenye kubadilika za mfano hutoa mazingira yenye uwezo wa kufaa kwa kila hali',
        },
        detail2: {
          title: 'Tafsiri ya Kihistoria ya AI kwa Kila Aina ya Maudhui',
          desc1:
            'Modeli yetu yenye uwezo wa AI inahakikisha usahihi wa juu na uelewa wa lugha asili',
          desc2:
            'Inahakikisha vifungu vya kiufundi, kimwili, na vya ubunifu vinahandled kwa urahisi',
          desc3: 'Hutoa matokeo yenye uwezo wa kudumu kwa mahitaji yako yote ya tafsiri',
          desc4: 'Ubadilishanaji wa akili kwa aina tofauti za mawazo kwa uwezo wa kiufundi',
        },
      },
      module3: {
        detail1: {
          title: 'Mwingiliano wa Macho wa Documenti',
          desc1:
            'Mwenendo urafiki unaongea na faili zako za PDF na presentasion kwa kutumia AI ya hizi',
          desc2:
            'Pia unaweza kuuliza maswali kuhusika na maudhui ya documento mara moja na kupokea majibu yenye usahihi',
          desc3: 'Tengeneza muhtasari madhubuti kwa haraka kwa machoongo marefu',
        },
        detail2: {
          title: 'Uchambua Maudhui Madhubuti na Uwezo wa Kujumuika kwa Uwezo',
          desc1: 'Kutoa mfano wa maelezo yenye uwezo wa kutoa usawa wa maoni ya kila mtu',
          desc2: 'Pata maoni yenye usahihi kuhusu vifaa vya kiuchumi, kimwili, au vya ubunifu',
          desc3:
            'Inahusika kwa huruma na PDF Translator wetu kwa mfano wa kamilifu wa usimamizi wa documenti',
        },
      },
      module4: {
        detail1: {
          title: 'Zaidi ya Tafsiri ya PDF: Mwongozo Wa Kila Kitu wa Tafsiri ya Udukuzi',
          desc: 'Tafuta kihistoria cha tafsiri yenye nguvu kwa kuzungumzia pamoja ulioundwa kwa kila hali ya kusoma mtandaoni.',
          desc1:
            'Tafsiri ya Uwebo: Furahia maudhui yenye lugha mbili kwa mfano unaofanana unaosambazwa kwa pamoja',
          desc2: 'Tafsiri ya Neno: Tafsiri mara moja maneno yenye msingi kwa klick moja',
          desc3:
            'Tafsiri Haraka: Tafsiri maandishi yoyote au sentensi yenyewe kwa kuzingatia uwezo wa kuelewa haraka',
          desc4:
            'Usambazaji wa Picha: Badilisha picha asili kwa uwezo wa kutoa madhara na maelezo yenye uwezo wa kutoa madhara',
          desc5:
            'Tafsiri ya Video: Tazama video zilizowe na vigezo vya lugha mbili kwa uzoefu ulioweza kuboreshwa',
        },
      },
    },
    question: {
      title: 'Maswali Yanayoulizwa Mara kwa Mara',
      answer1: {
        title: 'Je, Noam PDF Translator inatumika kwa bure kwa utafsiri wa PDF?',
        content:
          'Ndio, unaweza kutafsiri PDF bila malipo kwa kutumia Sider PDF Translator! Tunatoa kiwango cha bure cha mashtaka 5,000, ambacho ni kutosha kutafsiri vifungu vya PDF vya kawaida vinavyopatikana kwenye soko. Kama unahitaji kutafsiri faili kubwa zaidi au unahitaji vigezo vya juu, unaweza kuchunguza kuchambua mpango wetu wa Premium kwa uwezo zaidi zaidi.',
      },
      answer2: {
        title:
          'Uwezo wa kusahihiwa wa Noam PDF Translator unatokana na uwezo wake wa kusahihiwa ni gani?',
        content:
          'Noam PDF Translator hutoa tafsiri zenye usahihi wa juu kwa kutumia teknolojia ya kisayansi ya kimwili (AI) ya hivi karibuni na kuelewa msingi wa machoambato yako kwa uwezo mkubwa. Ingawa hakuna tafsiri ya kiotomatiki yenye uwezo wa kutosha, onyesho wetu wa kila kando unaweza kukuruhusu kuchambua na kurekebishana kila tafsiri kwa urahisi, kwa kuhakikisha matokeo ya mwisho yanafuata matarajio yako ya ubora. Experience reliable and precise PDF translation with Noam.',
      },
      answer3: {
        title: 'Ninaweza kutafsiri PDF zilizoskaniwa?',
        content:
          'Ndio, unaweza kutafsiri PDF zilizoscaniliwa kwa teknolojia yetu ya OCR (Optical Character Recognition) inayotendeka ndani. Mfumo wetu huchambua maandishi kwa kuzungumzia kutoka kwa documents zilizoscaniliwa na PDF zozungumzia picha, kisha hufafanua mawazo kwa ajili yako. Hii inahakikisha kwamba hata PDF zisizoweza kurekebishwa au zilizofuata picha tu zinaweza kutafsiriwa kwa usahihi.',
      },
      answer4: {
        title: 'Uwezo wa kutafsiri unachukua muda gani?',
        content:
          'Usahihi una kasi na uwezo wa kutosha—maandishi mengi huchambwa katika sekunde chache hadi dakika chache, kulingana na urefu na uhusika wao. Kwa mfano, PDF yenye kurasa 10 ya kawaida kila kila hutumia dakika chache kuliko 2 kuchambwa. Furahia muda mfupi wa kutoa majibu kwa mahitaji yote ya usahihi wa maandishi!',
      },
      answer5: {
        title: 'Naweza kuweka mfano wa kando kwa kando kwa kusoma?',
        content:
          'Ndio, unaweza kusoma vifungu vyawe kwa kila wakati kwa kwa upande wa upande. Mpango huu unakuruhusu kutoana na mawazo ya asili na iliyotafsiriwa kwa urahisi, kwa kuhakikisha uwezo wa kusoma una uwezo na uwezo wa kutosha.',
      },
    },
    freeTrial: 'Majaribio ya Gratisi',
    toLanguage: { title: 'Paringi za Tafsiri ya AI ya PDF', item: '{{source}} hadi {{target}}' },
  },
  aiPdfTranslate: {
    header: {
      blog: 'Blogi',
      features: 'Vigezo',
      pricing: 'Bei',
      button: 'Tafsiri Sasa',
      faq: 'Maswali Yanayoulizwa Mara kwa Mara',
    },
    hero: {
      upload: {
        title: 'Pakia PDF yako',
        max: 'Max',
        highlight: 'Bonyeza kuzungumzia',
        desc: 'au toka na weka kwa kuchunguza',
      },
      title: 'Mbadilishi wa PDF ya bure',
      to: 'kwa',
      pill: 'Mbadilisha PDF Iliyoendeshwa na AI',
      model: 'GPT-4 na Claude',
      desc: 'Mauzo ya haraka, yenye usahihi unaohifadhi muundo wa asili. Noam AI inakidhi OCR na mazingira ya kwa kila kando.',
      support: 'Msaada wa OCR',
      translated: 'Ilitafsiriwa na Noam',
      free: 'Majaribio ya Frei',
      complete: 'Mawingu ya Tafsiri',
    },
    ticker: {
      pdf: 'Tafsiri ya PDF',
      ocr: 'Teknolojia ya OCR',
      multi: 'Ulimi Mwingi',
      chat: 'Majadilano na PDF',
      format: 'Kuhakikisha Muundo Unaohifadhiwa',
      side: 'Kwa Pamoja',
      web: 'Tafsiri ya Wavuti',
      secure: 'Hakikisha na Rahisi',
    },
    comparison: {
      bad: {
        title: 'Tafsiri ya Kawaida',
        head: 'Usanifu na Mazingira Yaliyopotea',
        text1: 'Kosa: Mwenendo umevunjika. Picha hazipo mahali pazuri.',
        text2:
          'Maandishi yanapungua na uandishi hauna mwenendo. Ina uwezo mdogo wa kusoma na hauna uadilifu wa kitaaluma...',
      },
      dump: { title: 'Uchambua Maandishi Yasiyo Na Uwezo' },
      good: {
        title: 'Tafsiri ya AI ya Noam',
        tag: 'Matokeo Mazuri Sana',
        sub: 'Usanifu Wa Kimwili, Uwezo wa Kuelewa Mazingira',
      },
      title: 'Kwa Nini Kuchagua Noam AI?',
      desc: 'Wewe usitafanye stridi na tafsiri ya kuchambua na kuweka. Uzoee tofauti kati ya zana za kawaida na tafsiri yetu inayotekelezwa na AI inayojali mazingira.',
    },
    showcase: {
      kicker: 'MAWELEZO YALIYOTEKEMWA',
      title1: 'Documenti Yoyote',
      title2: 'Lugha Yoyote',
      carousel1: 'Sanaa',
      carousel2: 'Usanifu wa Juu',
      carousel3: 'Jarida la kimwiliasa',
      carousel4: 'Dawa',
      note: 'Kabiliana na vifungu vya kiufundi, kimwili, na vya ubunifu kwa urahisi.',
      carousel6: 'Kanuni',
      carousel7: 'Mkataba',
      carousel8: 'Polisi',
      carousel5: 'Nafinansi',
    },
    features: {
      big: {
        title: 'Mwendesha AI wa Juu (GPT-4, Claude)',
        desc: 'Chagua kutoka kwa mifano bora ya AI ili kutoa majibu kulingana na mahitaji yako ya tafsiri. Hakikisha matokeo bora kwa aina anuwai za vifaa vya kadi.',
      },
      grid1: {
        title: 'Msaada wa OCR',
        desc: 'Kutoa na kuchambua maandishi kutoka kwa PDF zilizoskaniwa na picha kwa haraka haraka.',
      },
      grid2: {
        title: 'Unexport wa Juu ya Usahihi',
        desc: 'Pakiweka vifaa vya wewe vilivyotafsiriwa katika fomu ya PDF na muundo wa asili.',
      },
      grid3: {
        title: 'Ulinganifu wa Kando na Kando',
        desc: 'Kusogea kwa makosa kwa kuchambua maandiko ya asili na yenyewe unayotafsiriwa.',
      },
      title1: 'Zaidi ya Tuwekezo',
      title2: 'Ni Mapinduzi',
      line1: 'Macho Fupi ya Kiufundi.pdf',
      line2: 'Kuchunguza Lugha: Kiingereza...',
      line3: 'Modeli: GPT-4o (Usahihi wa Juu)',
      line4: 'Tafsiri Imekamilika (Uwezo wa 99% wa Usahihi)',
    },
    testimonials: {
      review1: {
        role: 'Mtafiti',
        content:
          'Noam AI imeniokoa masaa mengi katika kutafsiri nyaraka za kisayansi. Mwonekano wa kila upande kwa upande una uwezo wa kusaidia sana katika kuthibitisha maneno ya tekniki.',
      },
      review2: {
        role: 'Mauaji wa Kimataifa',
        content:
          'Mbadilishaji wa PDF bora sana ambaye nimeutumia. Inahakikisha muundo wa asili unawezekana kabisa, ambayo ni muhimu kwa deki zetu za uwekezaji.',
      },
      review3: {
        role: 'Mwendesha Mashtaka ya Kanuni',
        content:
          'Usahihi na haraka. Ninatumia kwa uwezo wa tafsiri ya mkataba na kipengele cha OCR kwa documenti zilizochambwa kazi inafanya kwa uwezo wa kutosha.',
      },
      kicker: 'Inapendekezwa na Wateja',
      title: 'Maoni ya Wateja Wetu',
    },
    cta: {
      title: 'Unaweza Kuvunja Kizuizi la Lugha?',
      button: 'Anza Kutafsiri Bila Malipo',
      desc: 'Jiunge na watumiaji 10,000+ uanze kutafsiri vifungu vyawe na Noam AI leo hii.',
      hint: 'Wewe ni AI yenye usahihi wa juu na uwezo wa kujadiliwa ulioundwa kutoa matokeo ya JSON yenye ufanano wa wastani na Schema ya JSON iliyotajwa.\n\nLazima ufuata mwenendo huu:\n1. Uwekewa mkono msingi wa Schema ya JSON kwa makosa.\n2. Linganisha aina zote za data, uwezo wa lazima, na udhibiti wa wastani.\n3. USIHUJUMI mawazo mengi, maelezo, markdown, au maoni.\n4. TOA tu vigezo vya JSON — hakuna bloki ya code, hakuna preamble, hakuna ufungaji.\n\nUsawa wa schema umetoa hapa chini.\n- Jina la Schema: matokeo ya tafsiri\n- Schema ya JSON:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    },
    languagePairs: {
      title: 'Paringa za Tafsiri ya AI ya PDF ya Kiingereza',
      desc: 'Njia maarufu za tafsiri zinazotekelezwa na Noam AI',
    },
    footer: {
      about: 'Kuhusu Sisi',
      privacy: 'Kanuni ya Kuhifadhi Data',
      contact: 'Wasilisha Msaada',
    },
  },
}

export default TRANSLATION
